import React from 'react';

export type TFilterSwitchProps = {
    id: string;
    labels: string[];
    selectedFilter: string;
    setSelectedFilter: React.Dispatch<React.SetStateAction<string>>;
}

const ConfigurationFilter = ({id, labels, selectedFilter, setSelectedFilter }: TFilterSwitchProps) => {
    const capitalize = (str:string) => `${str.charAt(0).toUpperCase()}${str.slice(1)}`
    const handleButtonClick = (index: string) => {
        setSelectedFilter(index);
    };

    return (
        <div id={id} className={`tw-flex tw-rounded-[4px] tw-bg-[#7676801F] tw-p-1 tw-h-auto sm:tw-flex-auto sm:flex-col`}>
            {labels.map((label, index) => (
                <React.Fragment key={index + label}>
                    <button 
                        id={`${id}-filter-btn-${index}`}
                        className={`tw-flex-grow tw-py-1 tw-text-[13px] tw-px-4 sm:tw-px-3.5 sm:tw-w-auto tw-max-w-[120px] tw-overflow-hidden tw-whitespace-nowrap ${
                            label === selectedFilter
                                ? 'tw-rounded-[4px] tw-py-1.5 tw-font-semibold tw-bg-white tw-text-blue-800 tw-shadow tw-border tw-border-black tw-border-opacity-5 tw-flex tw-items-center tw-justify-center   transition duration-300 ease-in-out'
                                : 'tw-flex tw-font-normal tw-items-center tw-justify-center transition duration-300 ease-in-out'
                            } tw-rounded`}
                        onClick={() => handleButtonClick(label)}
                    >
                        <span id={`${id}-filter-text-${index}`}>
                            {capitalize(label)}
                        </span>
                    </button>
                </React.Fragment>
            ))}
        </div>
    );
};

export default ConfigurationFilter;
